export function encodeSocketMessage(data) {
  const bytes = new TextEncoder().encode(JSON.stringify(data))
  return btoa(Array.from(bytes, byte => String.fromCharCode(byte)).join(''))
}

export function decodeSocketMessage(data) {
  if (typeof data === 'string' && data.trim().startsWith('"')) data = JSON.parse(data)
  return JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(data), char => char.charCodeAt(0))))
}

// Returns a cleanup function; each caller owns its connection and timers.
export function connectSocket({ url, getMessages, onMessage, onOpen = () => {}, onClose = () => {}, interval = 6000 }) {
  let socket, pollTimer, retryTimer, stopped = false
  function send() {
    if (!socket || socket.readyState !== WebSocket.OPEN) return
    for (const message of getMessages()) socket.send(encodeSocketMessage(message))
  }
  function retry() {
    onClose()
    clearInterval(pollTimer)
    clearTimeout(retryTimer)
    if (!stopped) retryTimer = setTimeout(connect, 3000)
  }
  function connect() {
    if (stopped) return
    try { socket = new WebSocket(url) } catch (_) { retry(); return }
    socket.onopen = () => { onOpen(); send(); if (interval > 0) pollTimer = setInterval(send, interval) }
    socket.onmessage = event => {
      let data
      try { data = decodeSocketMessage(event.data) } catch (_) { return }
      onMessage(data)
    }
    socket.onclose = retry
    socket.onerror = () => { socket.close() }
  }
  if (/^wss?:\/\//i.test(url || '')) connect()
  const cleanup = () => {
    stopped = true
    clearInterval(pollTimer)
    clearTimeout(retryTimer)
    if (socket) {
      socket.onopen = socket.onmessage = socket.onclose = socket.onerror = null
      socket.close()
    }
  }
  cleanup.send = message => {
    if (stopped || !socket || socket.readyState !== WebSocket.OPEN) return false
    socket.send(encodeSocketMessage(message))
    return true
  }
  return cleanup
}
